/**
 * Formatação específica dos focos. Datas/horas e números genéricos vêm dos
 * helpers canônicos `src/lib/time.ts` e `src/lib/format.ts`.
 */

const decimalFormats = new Map<string, Intl.NumberFormat>();

/** Número decimal pt-BR ("0,47", "110,7"); `min` casas fixas, até `max`. */
export function formatDecimal(n: number, max: number, min = 0): string {
  const key = `${min}|${max}`;
  let nf = decimalFormats.get(key);
  if (!nf) {
    nf = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: min, maximumFractionDigits: max });
    decimalFormats.set(key, nf);
  }
  return nf.format(n);
}

export interface RiskClass {
  label: 'Mínimo' | 'Baixo' | 'Médio' | 'Alto' | 'Crítico';
  color: string;
}

/**
 * Classe do risco de fogo (0–1) pelas faixas do INPE ("Risco de Fogo:
 * metodologia do cálculo", v9): Mínimo ≤ 0,15 < Baixo ≤ 0,40 < Médio ≤ 0,70
 * < Alto ≤ 0,95 < Crítico.
 */
export function riskClass(r: number): RiskClass {
  if (r <= 0.15) return { label: 'Mínimo', color: '#22c55e' };
  if (r <= 0.4) return { label: 'Baixo', color: '#a3e635' };
  if (r <= 0.7) return { label: 'Médio', color: '#facc15' };
  if (r <= 0.95) return { label: 'Alto', color: '#f97316' };
  return { label: 'Crítico', color: '#b91c1c' };
}

/** Siglas das UFs pelo código IBGE. */
const UF_BY_CODE: Record<number, string> = {
  11: 'RO', 12: 'AC', 13: 'AM', 14: 'RR', 15: 'PA', 16: 'AP', 17: 'TO',
  21: 'MA', 22: 'PI', 23: 'CE', 24: 'RN', 25: 'PB', 26: 'PE', 27: 'AL', 28: 'SE', 29: 'BA',
  31: 'MG', 32: 'ES', 33: 'RJ', 35: 'SP', 41: 'PR', 42: 'SC', 43: 'RS',
  50: 'MS', 51: 'MT', 52: 'GO', 53: 'DF',
};

export function ufSigla(code: number | null | undefined): string | null {
  return code ? (UF_BY_CODE[code] ?? null) : null;
}

const LOWER_WORDS = new Set(['de', 'da', 'do', 'das', 'dos', 'e', "d'"]);

/** "NOVO ARIPUANÃ" → "Novo Aripuanã"; "BARRA DO CORDA" → "Barra do Corda". */
export function titleCasePt(s: string): string {
  return s
    .toLocaleLowerCase('pt-BR')
    .split(/(\s+|-)/)
    .map((w, i) => (i > 0 && LOWER_WORDS.has(w) ? w : w.charAt(0).toLocaleUpperCase('pt-BR') + w.slice(1)))
    .join('');
}
